// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"551a8b19","5551":"77fdfaa6","5839":"f20a9d1f","6966":"081cb58b","9643":"8432b044"}[chunkId] + ".chunk.css";
};